/**
 * @generated SignedSource<<d096be33fe4ac897a5d78baf755d7b3a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useReadAndWriteContentQueryDataCacheWriteContentFragment$data = {
  readonly body: {
    readonly dynamic: {
      readonly representation: string | null | undefined;
      readonly value: string | null | undefined;
      readonly webresource: {
        readonly superbatch: {
          readonly tags: {
            readonly css: string | null | undefined;
            readonly js: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly tags: {
          readonly css: string | null | undefined;
          readonly js: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useReadAndWriteContentQueryDataCacheWriteContentFragment";
};
export type useReadAndWriteContentQueryDataCacheWriteContentFragment$key = {
  readonly " $data"?: useReadAndWriteContentQueryDataCacheWriteContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useReadAndWriteContentQueryDataCacheWriteContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useReadAndWriteContentQueryDataCacheWriteContentFragment",
  "selections": [
    {
      "concreteType": "ContentBodyPerRepresentation",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "dynamic",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "representation"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SuperBatchWebResources",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "0070fa1f6967d8f3323abe02720a0286";

export default node;
